export const AGENT_PANEL_CSS = /* css */ `
  .lk-widget-agent {
    display: flex; flex-direction: column; height: 100%;
    container-type: inline-size; container-name: widget;
  }

  /* ── Split layout: video left, chat right ── */
  .lk-widget-split {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  .lk-widget-split-video {
    flex: 1;
    min-width: 0;
    background: #000;
  }
  .lk-widget-split-chat {
    width: 340px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-left: 1px solid var(--wg-border);
    overflow: hidden;
  }

  /* Loading / error state while avatar provisions */
  .lk-widget-avatar-loading {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: rgba(255,255,255,0.85);
    font-size: 14px;
    font-weight: 500;
    background: #000;
    overflow: hidden;
  }
  .lk-widget-avatar-loading-bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    transform: scale(1.15);
    animation: avatar-breathe 3s ease-in-out infinite;
  }
  @keyframes avatar-breathe {
    0%, 100% { opacity: 0.5; filter: blur(20px); }
    50% { opacity: 0.7; filter: blur(16px); }
  }
  .lk-widget-avatar-loading-text {
    position: relative;
    z-index: 1;
    text-shadow: 0 1px 8px rgba(0,0,0,0.6);
  }
  .lk-widget-avatar-error {
    cursor: pointer;
  }
  .lk-widget-avatar-error:hover .lk-widget-avatar-loading-text {
    color: #fff;
  }

  /* On mobile / narrow panels, video takes over the full area */
  @media (max-width: 768px) {
    .lk-widget-split-video {
      flex: 1;
    }
    .lk-widget-split-chat {
      display: none;
    }
  }
`;
